import { render } from "./MallDetails.vue?vue&type=template&id=2d158b90&scoped=true"
import script from "./MallDetails.vue?vue&type=script&lang=js"
export * from "./MallDetails.vue?vue&type=script&lang=js"

import "./MallDetails.vue?vue&type=style&index=0&id=2d158b90&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-2d158b90"

export default script